import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import { Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import "./../../Style/POS.scss";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import jwtDecode from "jwt-decode";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
} from "../../Components/Alerts";
import Modal_bootstrap from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import Button_Bootstrap from 'react-bootstrap/Button';
import { useHistory } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import HighlightOffSharpIcon from "@mui/icons-material/HighlightOffSharp";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FilledInput from "@mui/material/FilledInput";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import EuroIcon from "@mui/icons-material/Euro";
import PaymentIcon from "@mui/icons-material/Payment";
import CancelIcon from "@mui/icons-material/Cancel";
import { Typography, Modal } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DateRangeIcon from '@mui/icons-material/DateRange';
import BusinessIcon from '@mui/icons-material/Business';
import { saveAs } from 'file-saver';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { getUnitID } from "../../Auth/GetUnitCompany";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { executeTermolPrinter } from "../../Print/TermolFiscalPrinter";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
function AddPos(props) {
  const history = useHistory();
  const { fiscalYear } = useContext(FiscalYearContext);
  const [isInactive, setIsInactive] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);  // Kyçi për rifreskim të komponentëve
  const timerRef = useRef(null);
  const termolFiscalPrinter = useRef(null);

  const [fiscalPrinterType, setPrinterFiscalType] = useState("");

  const headers = authHeader();
  const email = LoginUserDetailed();
  const [logedEmail, setLogedEmail] = useState("");
  // const currentYear = new Date().getFullYear();
  const [openCashModal, setOpenCashModal] = useState(false);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [openZraportConfirm, setOpenZraportConfirm] = useState(false);
  const [openXraportConfirm, setOpenXraportConfirm] = useState(false);
  const [openQtyAlert, setOpenQtyAlert] = useState(false);
  const [isArticleQtySelected, setIsArticleQtySelected] = useState(false);
  const [showClosePosAlert, setShowClosePosAlert] = useState(false);
  const [showPriceError, setShowPriceError] = useState(false);
  const [showClosePOSModal, setShowClosePOSModal] = useState(false);


  const [openQtyModal, setOpenQtyModal] = useState(false);
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [tempQty, setTempQty] = useState(0);
  const [tempPrice, setTempPrice] = useState(0);
  const [tempArticle, setTempArticle] = useState([]);

  const pagesaFokus = useRef(null);

  //Per insertimin e Transaction
  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [coment, setComent] = useState("");
  const [invoiceNR, setInvoiceNR] = useState("");
  const [clientID, setClientID] = useState(0);
  const [transactionsType, setTransactionType] = useState(1);
  const [paymentOptions, setPaymentOptions] = useState(0);
  const [priceWithVAT, setPriceWithVAT] = useState(0);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [clientName, setClientName] = useState('');
  const [articleID, setArticleID] = useState("");
  const [articleName, setArticleName] = useState("");
  const [qtyOutput, setQtyOutput] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [priceWithoutVAT, setPriceWithoutVAT] = useState(0);
  const [total, setTotal] = useState(0);
  const [vatRates, setVATRates] = useState("");
  const [unId, setUnID] = useState('')
  const [tempPriceWithVAT, setTempPriceWithVAT] = useState(0);
  const [showDeleteTransactionID, setShowDeleteTransactionID] = useState(false);

  const [deleteTransactionID, setDeleteTransactionID] = useState("");

  const [data, setData] = useState([]);
  const [banks, setBanks] = useState([])

  // const [clients, setClients] = useState([]);

  const [articles, setArticles] = useState([]);

  const [valuedetails, setValueDetails] = useState([]);
  const [totaliFatures, setTotaliFatures] = useState(0);
  // Te dhenat per printim
  const [companyName, setCompanyName] = useState("");

  // const [groupID, setGroupID] = useState(0);
  const [articleGroup, setArticleGroup] = useState([]);
  const [articleByGroup, setArticleByGroup] = useState([]);

  //Ketu ruhen te dhenat per user detils, dhe payments
  const [tempPaymentOption, setTempPaymentOptions] = useState(0);
  const [cashRegisterName, setCashRegisterName] = useState("");

  const barcodeRef = useRef(null);
  const articleList = useRef(null);
  const pagesaArke = useRef(null);
  const qtyInputField = useRef(null);
  const priceInputField = useRef(null);

  const [pagesa, setPagesa] = useState(0);
  const [kusuri, setKusuri] = useState(0);
  const [insertedTransaction, setInsertedTransaction] = useState(false);
  const [insertedArticle, setInsertedArticle] = useState(false);
  const [barcode, setBarcode] = useState("");
  const [searchByBarcode, setSearchByBarcode] = useState(true);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000); // rifresko kohën çdo 1 sekondë

    return () => clearInterval(intervalId); // ndal intervalin kur komponenti zhduket
  }, []);

  const formattedTime = time.toLocaleTimeString();
  const formattedDate = time.toLocaleDateString();

  const [selectArticleField, setSelectArticleField] = useState(null);
  const handleAutocompleteChangeArticle = (event, value) => {
    if (value && value.ArticleID) {
      setArticleID(value.ArticleID);
      fetchArticlesSalesPrice(value.ArticleID, 'insert');
      setSelectArticleField(value);
      // if (!insertedTransaction) {
      //   handleSubmit(event);
      // }
    } else {
      // Në rast se vlera është pastruar
      setArticleID(""); // Vendos vlerën e ArticleID në null
      setSelectArticleField(null);
    }
  };


  const defaultPropsArticle = {
    options: articles,
    getOptionLabel: (option) => option.ArticleName || "",
  };

  ////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (transactionsType == 2 || transactionsType == 3) {
      setVATRates(0);
    }
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLogedEmail(decodedToken.email);
    }
  }, []);

  //E bart fokusin tek pagesa 
  useEffect(() => {
    if (openCashModal && pagesaFokus.current) {
      pagesaFokus.current.focus();
    }
  }, [openCashModal]);

  const fetchLastInvoiceNr = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "POS/InvoiceNr", {
        headers,
      });
      setInvoiceNR(response.data.NextInvoiceNr);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // e merr listen e aartikujve
  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "POS/POSDetails", {
        headers,
        params: { invNumber: invoiceNR, fiscalYear: fiscalYear },
      });
      setData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchPOS = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "POS/getPOS", {
        headers
      });
      setClientID(response.data[0].AccountID);
      setClientName(response.data[0].AccountName);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchTransactionID = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "POS/GetTransactionID",
        { headers, params: { email: logedEmail, invNumber: invoiceNR, fiscalYear: fiscalYear } }
      );
      setDeleteTransactionID(response.data);
      // Kontrollo nëse nuk ka të dhëna të disponueshme
      if (response.data.length === 0) {
        // Shfaqi një mesazh për përdoruesin
        // errorAlert("No data available.");
      }
    } catch (error) {
      // Shfaqi një mesazh për përdoruesin për gabimin e tjera
      // setMessage("Error: Failed to fetch data.");
    }
  };

  const fetchArticleGroup = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "articlegroup", {
        headers,
      });
      setArticleGroup(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleByGroup = async (group) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/ArticleByGroupAndTouchScreen",
        { headers, params: { group: group } }
      );
      setArticleByGroup(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchCompaniesData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers }
      );
      setCompanyName(response.data[0].CompanyName);
      setPrinterFiscalType(response.data[0].FiscalPrinter);
      // setCompanyEmail(response.data[0].Email);
      // setcompanyID(response.data[0].CompanyID);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // const [totalWithDiscountAmount, setTotalWithDiscountAmount] = useState(0);

  const fetchvaluedetails = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "POS/getvaluedetails",
        { headers, params: { invNumber: invoiceNR, fiscalYear: fiscalYear } }
      );
      setValueDetails(response.data);
      setTotaliFatures(response.data[0].Total)
      setPagesa(response.data[0].Total)
      // setDiscountAmount(response.data[0].DiscountAmount);
      // setTotalWithDiscountAmount(
      //   response.data[0].Total + response.data[0].DiscountAmount
      // );
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + 'UserDetails/getPaymentDetailsForUsers', { headers });
      setTempPaymentOptions(response.data[0].AccountID ? response.data[0].AccountID : 0);
      setCashRegisterName(response.data[0].AccountName ? response.data[0].AccountName : '');

    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (error.response && error.response.data && error.response.data.errorMessage) {
        errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // const fetchClients = async () => {
  //   try {
  //     const response = await axios.get(
  //       ApiLink.API_URL + "Accounts/accountByLedger",
  //       { headers, params: { ledger: 105 } }
  //     );
  //     const clientsFromDatabase = response.data;

  //     // Shtoni opsionin e konsumatorit privat në fillim të listës
  //     const updatedClients = [
  //       { AccountID: 0, AccountName: "Konsumator privat" },
  //       ...clientsFromDatabase,
  //     ];

  //     setClients(updatedClients);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);
  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message} `);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };



  const fetchArticles = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Article", {
        headers,
      });
      setArticles(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchArticlesSalesPrice = async (articleID, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPrice",
        { headers, params: { articleID: articleID } }
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja
      if (form == "edit") {
        const calculatedValue =
          (parseFloat(response.data.SalesPrice) * 100) /
          (100 + response.data.SalesPrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);
        // setTempPriceWithVAT(salesPriceData.SalesPrice);
        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.SalesPrice,
          PriceWithoutVAT: calculatedValue,
          DiscountPercent: 0,
          QtyOutput: 1,
          PriceBeforeDiscount: response.data.SalesPrice,
          Total: 1 * response.data.SalesPrice,
        }));
      } else if (form == "getVat") {
        setVATRates(response.data.VATRates);
        // alert("get vat" + vatRates)
      } else {
        // setPriceWithVAT(salesPriceData.SalesPrice);
        setPriceWithVAT(Number(salesPriceData.SalesPrice).toFixed(2));

        setTempPriceWithVAT(Number(salesPriceData.SalesPrice).toFixed(2));
        setVATRates(salesPriceData.VATRates);
        setQtyOutput(1);
        setArticleName(salesPriceData.ArticleName);
        // console.log(salesPriceData);
        // console.log(articleID);

        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.SalesPrice) * 100) /
          (100 + salesPriceData.VATRates);
        setPriceWithoutVAT(calculatedValue.toFixed(2));
        setTotal(1 * salesPriceData.SalesPrice);

        //ky kushtt sherben per tu insertuar transaksioni nese klikohen butonat me touch, duhet te ploteohen te dy keto kushte pet tu insertuar
        if (!insertedTransaction && form === 'insert') {
          handleSubmit();
        }
        if (salesPriceData.PurchasePrice >= salesPriceData.SalesPrice) {
          setShowPriceError(true);
        }
        else {
          setShowPriceError(false);
          setArticleName("");
        }
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };




  // const [articleExist, setArticleExist] = useState(false);
  const fetchArticlesSalesPriceByBarcode = async (barcode, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPriceByBarcode",
        { headers, params: { barcode: barcode } }
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja
      if (form === "edit") {
        const calculatedValue =
          (parseFloat(response.data.SalesPrice) * 100) /
          (100 + response.data.SalesPrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);
        // setTempPriceWithVAT(salesPriceData.SalesPrice);
        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.SalesPrice,
          PriceWithoutVAT: calculatedValue,
          DiscountPercent: 0,
          QtyOutput: 1,
          PriceBeforeDiscount: response.data.SalesPrice,
          Total: 1 * response.data.SalesPrice,
        }));
      } else if (form === "getVat") {
        setVATRates(response.data.VATRates);
        // alert("get vat" + vatRates)
      } else {
        setArticleID(salesPriceData.ArticleID);
        setPriceWithVAT(Number(salesPriceData.SalesPrice).toFixed(2));
        // setPriceWithVAT(salesPriceData.SalesPrice);
        setPurchasePrice(salesPriceData.PurchasePrice);
        setTempPriceWithVAT(salesPriceData.SalesPrice);
        setVATRates(salesPriceData.VATRates);
        setQtyOutput(1);
        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.SalesPrice) * 100) /
          (100 + salesPriceData.VATRates);
        setPriceWithoutVAT(calculatedValue.toFixed(2));
        setTotal(1 * salesPriceData.SalesPrice);
        setArticleName(salesPriceData.ArticleName);

        // setArticleExist(true);
        setInsertedArticle(true);

        if (!insertedTransaction) {
          handleSubmit();
        }

        if (salesPriceData.PurchasePrice >= salesPriceData.SalesPrice) {
          setShowPriceError(true);
        }
        else {
          setShowPriceError(false);
          setArticleName("");

        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status === 404 &&
        error.response.data &&
        error.response.data.Message
      ) {
        // Kontrolloni nëse artikulli nuk ekziston
        // errorAlert(`Gabim: ${error.response.data.Message}`);
        // setArticleExist(false);
        setInsertedArticle(false);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleDelete = async (deleteItemId) => {
    try {
      await axios.delete(ApiLink.API_URL + "POS/oneline" + `/${deleteItemId}`, {
        headers,
        params: { email: logedEmail, invoiceNR: invoiceNR, fiscalYear: fiscalYear },
      });
      fetchData();
      fetchvaluedetails();
      setShowPriceError(false);
      setArticleName("");
      // fetchHeaderData();
      // fetchArticleDataPrint();
    } catch (error) {
      deleteAlert("Purchase detail can not be deleted");
    }
  };

  // Kodi per fshirjen e nje elementi ne databaz
  const handleDeleteTransactionID = async (show) => {
    try {
      // const response =
      await axios.delete(ApiLink.API_URL + "POS" + `/${deleteTransactionID}`, {
        headers,
      });
      setShowDeleteTransactionID(false);
      fetchLastInvoiceNr();
      setData([]);
      fetchArticleGroup([]);
      setValueDetails([]);
      setTotaliFatures(0);
      setKusuri(0);
      setPagesa(0);
      setInsertedTransaction(false)
      if (show === "show") {
        deleteAlert("Fatura eshte fshire me sukses");
      }
      setShowPriceError(false);

    } catch (error) {
      deleteAlert("Sales Invoice can not be deleted");
    }
  };

  //Funksioni per navigim ne listen e POS, dhe fshirjen e elementeve ekzistuese
  const navigateToPos = async () => {
    setData([]);
    fetchArticleGroup([]);
    setValueDetails([]);
    setTotaliFatures(0);
    setKusuri(0);
    setPagesa(0);
    setInsertedTransaction(false);
    history.push('/Sales/pos');

  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      return;
    }
    if (!date) {
      errorAlert("Ju lutem plotësoni Daten!");
      return;
    }

    if (paymentOptions != 0 && payDate == "") {
      errorAlert("Please Fill pay date");
      return;
    }

    const stateDate = {
      Date: date,
      PayDate: payDate,
      InvoiceNr: invoiceNR,
      SupplierID: clientID,
      TransactionType: transactionsType,
      ActionType: "POS",
      PaymentOptions: paymentOptions,
      CompanyUnitID: unId > 0 ? unId : null,
      Coment: coment,
      CreatedByUser: email,
    };
    axios
      .post(ApiLink.API_URL + "POS/invoicedetail", stateDate, { headers })
      .then(() => {
        // handleSuccess("Inserted");
        // handleEnable();
        // fetchHeaderData();
        fetchTransactionID();
        setInsertedTransaction(true);
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };

  const handleNewSubmit = (event) => {
    if (event) event.preventDefault();
    if (!invoiceNR) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      // console.log(`Invoice number tek new ${invoiceNR}`);
      return;
    }
    if (!articleID) {
      errorAlert("Ju lutem plotësoni artikullin");
      // alert(`article id tel new ${articleID}`);

      return;
    }
    if (isNaN(qtyOutput)) {
      errorAlert("Sasia e produkteve (qtyOutput) duhet të jetë një numër.");
      return;
    }
    if (isNaN(priceWithoutVAT)) {
      errorAlert("Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.");
      return;
    }
    if (isNaN(priceWithVAT)) {
      errorAlert("Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.");
      return;
    }
    if (isNaN(total)) {
      errorAlert("Totali duhet të jetë një numër.");
      return;
    }
    const stateDate = {
      InvoiceNr: invoiceNR,
      ArticleID: articleID,
      QtyOutput: qtyOutput,
      DiscountPercent: discountPercent,
      PriceBeforeDiscount: tempPriceWithVAT,
      PriceWithoutVAT: priceWithoutVAT,
      PriceWithVAT: priceWithVAT,
      CreatedByUser: email,
      Date: date,
      SupplierID: clientID,
      CompanyUnitID: unId > 0 ? unId : null
    };
    axios
      .post(ApiLink.API_URL + "POS/createnewline", stateDate, {
        headers,
        params: { vatRates: vatRates },
      })
      .then(() => {
        // handleSuccess("Detail  Added Successfully");
        setArticleID("");
        setQtyOutput(0);
        setDiscountPercent(0);
        setPriceWithoutVAT(0);
        setPriceWithVAT(0);
        setTotal(0);
        fetchvaluedetails();
        // fetchHeaderData();
        // fetchArticleDataPrint();
        // setArticlesName("");
        fetchData();
        setDiscountPercent(0);
        setTempPriceWithVAT(0);
        setBarcode("");
        setInsertedArticle(false);
        setSelectArticleField(null);
        // setShowPriceError(false);
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };
  // const [detailLine, setDetailLine] = useState([]); //i mban rreshtat e te dhenave detale
  const [formDetailData, setFormDetailData] = useState({
    HistoryID: "",
    ArticleID: "",
    QtyOutput: "",
    DiscountPercent: "",
    PriceBeforeDiscount: "",
    Total: "",
    PriceWithVAT: "",
    PriceWithoutVAT: "",
    ModifiedByUser: "",
    InvoiceNr: "",
    PaymentOptions: "",
  });

  const handleChangeQty = async (item, qty, operation) => {
    try {
      const detailsData = {
        HistoryID: item.HistoryID,
        ArticleID: item.ArticleID,
        QtyOutput: operation === '-'
          ? (Number(item.QtyOutput) > 1
            ? Number(item.QtyOutput) - Number(qty)
            : Number(item.QtyOutput))
          : Number(item.QtyOutput) + Number(qty),
        DiscountPercent: item.DiscountPercent,
        PriceBeforeDiscount: item.PriceBeforeDiscount,
        Total: item.Total,
        PriceWithVAT: item.PriceWithVAT,
        PriceWithoutVAT: item.PriceWithoutVAT,
        ModifiedByUser: logedEmail,
        InvoiceNr: invoiceNR,
        PaymentOptions: paymentOptions,
      };

      await axios.put(ApiLink.API_URL + "POS/updatedetailsArticle", detailsData, {
        headers,
        params: { vatRates: item.VATRates, fiscalYear: fiscalYear }
      });

      // Fetched data pas suksesit
      fetchvaluedetails();
      fetchData();
    } catch (error) {
      console.error(error);
      errorAlert("Failed to update details");
    }
  };

  const handleChangeQtyWithInput = async (item, value, type) => {
    try {

      let detailsData = {};
      if (type === "qty") {
        detailsData = {
          HistoryID: item.HistoryID,
          ArticleID: item.ArticleID,
          QtyOutput: value,
          DiscountPercent: item.DiscountPercent,
          PriceBeforeDiscount: item.PriceBeforeDiscount,
          Total: item.Total,
          PriceWithVAT: item.PriceWithVAT,
          PriceWithoutVAT: item.PriceWithoutVAT,
          ModifiedByUser: logedEmail,
          InvoiceNr: invoiceNR,
          PaymentOptions: paymentOptions,
        };
      }
      else {
        detailsData = {
          HistoryID: item.HistoryID,
          ArticleID: item.ArticleID,
          QtyOutput: item.QtyOutput,
          DiscountPercent: item.DiscountPercent,
          PriceBeforeDiscount: value,
          Total: item.Total,
          PriceWithVAT: value,
          PriceWithoutVAT: item.PriceWithoutVAT,
          ModifiedByUser: logedEmail,
          InvoiceNr: invoiceNR,
          PaymentOptions: paymentOptions,
        };
      }

      // Thirrja e API-së
      const response = await axios.put(`${ApiLink.API_URL}POS/updatedetailsArticle`, detailsData, {
        headers,
        params: { vatRates: item.VATRates, fiscalYear: fiscalYear }
      });

      // Logimi i përgjigjes nga serveri
      // console.log("Response from API:", response);

      // Kontrollo nëse përgjigjja nga serveri është pozitive
      if (response.status === 200 || response.status === 204) {
        // console.log("Update successful");

        // Mbyll modalin dhe fresko të dhënat
        if (type === "qty") {
          setOpenQtyModal(false);
          setTempArticle([]);
          setTempQty(0);
          setIsArticleQtySelected(false);
        }
        else {
          setOpenPriceModal(false);
          setTempArticle([]);
          setTempPrice(0);
          setShowPriceError(false);
          setIsArticleQtySelected(false);
        }


        // console.log("Modal closed and data reset. Fetching new data...");

        // Fresko të dhënat
        fetchvaluedetails();
        fetchData();
      } else {
        // console.error("Update failed with status code:", response.status);
        alert("Update failed. Please try again.");
      }
    } catch (error) {
      // Logimi i gabimit në console dhe njoftimi i përdoruesit
      console.error("Error during the update process:", error);
      // alert("Failed to update details");
    }
  };

  const handleUpdatePayments = (event) => {
    event.preventDefault();

    const formDetailData = {
      ModifiedByUser: email,
      InvoiceNr: invoiceNR,
      PaymentOptions: paymentOptions
    };
    let nr = `POS-${fiscalYear}-${invoiceNR}`;

    axios
      .put(ApiLink.API_URL + "POS/setPaymentOptions", formDetailData, {
        headers, params: { fiscalYear: fiscalYear }
      })
      .then((response) => {
        if (openCashModal) {
          setOpenCashModal(false);
          handleSuccess("Pagesa u perfundua ne ark");
          fetchLastInvoiceNr();
          setData([]);
          fetchArticleGroup([]);
          setValueDetails([]);
          setTotaliFatures(0);
          setInsertedTransaction(false)
          setPagesa(0);
          setKusuri(0);
          // fetchClients();
          setShowClosePosAlert(false);
          setPaymentOptions(0);
          setShowPriceError(false);
          if (data) {
            if (fiscalPrinterType == 2) {
              executeTermolPrinter(data, nr); // Thirr funksionin e printerit fiskal
            }
            else {
              downloadReceiptFile(data)
            }
          }
          else {
            errorAlert("Nuk keni te dhena per ta printuar kuponin fiskal")
          }
        } else {
          if (paymentOptions !== 0) {
            setOpenBankModal(false);
            handleSuccess("Pagesa u perfundua ne bank");
            fetchLastInvoiceNr();
            setData([]);
            fetchArticleGroup([]);
            setValueDetails([]);
            setTotaliFatures(0);
            setInsertedTransaction(false)
            setPagesa(0);
            setKusuri(0);
            // fetchClients();
            setShowClosePosAlert(false);
            setPaymentOptions(0);
            setShowPriceError(false);

            if (data) {
              if (fiscalPrinterType == 2) {
                executeTermolPrinter(data, nr); // Thirr funksionin e printerit fiskal
              }
              else {
                downloadReceiptFile(data)
              }
            }
            else {
              errorAlert("Nuk keni te dhena per ta printuar kuponin fiskal")
            }
          }
          else {
            errorAlert("Ju lutem zgjedheni banken")
          }
        }
      })
      .catch((error) => {
        // Log për të parë detajet e error-it
        console.error("Error: ", error);
        setPaymentOptions(0)
        errorAlert("Nuk eshte paguar ende");
      });
  };
  // const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      // setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const setCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    setDate(formattedDate);
    setPayDate(formattedDate);
  };

  const insertArticlerOnClick = async (articleID) => {
    await fetchArticlesSalesPrice(articleID, 'insert');
    setArticleID(articleID);
    setInsertedArticle(true);
  };

  useEffect(() => {
    if (insertedArticle) {
      handleNewSubmit();
    }
  }, [insertedArticle]);


  const rows = data.map((item, index) => ({
    id: ++index,
    barcode: item.Barcode,
    name: item.ArticleName,
    sasia: item.QtyOutput,
    price: item.PriceWithVAT,
    amountNoVAT: item.Amount,
    total: item.Total,
    itemID: item.HistoryID,
    rowInfo: item,
  }));

  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 10,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "barcode",
      headerName: "Barkodi",
      width: 150,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "name",
      headerName: "Emertimi",
      width: 320,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "sasia",
      headerName: "Sasia",
      width: 100,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "price",
      headerName: "Cmimi",
      type: "string",
      width: 100,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: true,
      valueFormatter: (value) => {
        if (!value) {
          return value;
        }
        return currencyFormatter.format(value);
      },
    },
    {
      field: "total",
      headerName: "Total",
      type: "string",
      width: 100,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: true,
      valueFormatter: (value) => {
        if (!value) {
          return value;
        }
        return currencyFormatter.format(value);
      },
    },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const kalkuloKusur = async (paguar,) => {

    const calc = Number(paguar) - Number(totaliFatures);
    setKusuri(calc)
  }


  const fetchBanks = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 102 } });
      setBanks(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (error.response && error.response.data && error.response.data.errorMessage) {
        errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const [actionTriggered, setActionTriggered] = useState(false); // Për të menaxhuar ekzekutimin e funksioneve

  const handleKeyPress = useCallback((event) => {
    switch (event.key) {
      case 'F1':
        event.preventDefault();
        if (!searchByBarcode) {
          setSearchByBarcode(true);
          setTimeout(() => barcodeRef.current?.focus(), 0);
        }
        break;
      case 'F2':
        event.preventDefault();
        if (searchByBarcode) {
          setSearchByBarcode(false);
          setTimeout(() => articleList.current?.focus(), 0);
        }
        break;
      case 'F4':
        event.preventDefault();
        if (!isArticleQtySelected) {
          setOpenQtyAlert(true);  // Show alert if article is not selected
        } else {
          setOpenQtyAlert(false);  // Hide alert when modal opens
          if (!openPriceModal) {
            setOpenPriceModal(true);  // Open modal if article is selected
            setTimeout(() => priceInputField.current?.focus(), 0);  // Focus input
          }
        }
        break;
      case 'F5':
        event.preventDefault();
        if (!isArticleQtySelected) {
          setOpenQtyAlert(true);  // Show alert if article is not selected
        } else {
          setOpenQtyAlert(false);  // Hide alert when modal opens
          if (!openQtyModal) {
            setOpenQtyModal(true);  // Open modal if article is selected
            setTimeout(() => qtyInputField.current?.focus(), 0);  // Focus input
          }
        }
        break;
      case 'F6':
        event.preventDefault();
        if (!openCashModal) {
          setOpenCashModal(true);
          setPaymentOptions(tempPaymentOption);
          setTimeout(() => pagesaArke.current?.select(), 0);
        }
        break;
      case 'F7':
        event.preventDefault();
        if (!openBankModal) {
          setOpenBankModal(true);
        }
        break;
      case 'F10':
        event.preventDefault();
        setOpenXraportConfirm(true);
        break;
      case 'F11':
        event.preventDefault();
        setOpenZraportConfirm(true);
        break;
      case 'F12':
        event.preventDefault();
        setShowDeleteTransactionID(true);
        break;
      case 'Enter':
        event.preventDefault();
        if (openCashModal || openBankModal) {
          if (totaliFatures === 0) {
            errorAlert("Nuk ka asnje produkt ne grid per ta printuar kuponin");
            setOpenCashModal(false);
          } else {
            handleUpdatePayments(event);
          }
        } else {
          setActionTriggered(true);
        }
        break;
      default:
        break;
    }
  }, [searchByBarcode, openCashModal, openBankModal, openQtyModal, totaliFatures, isArticleQtySelected]);

  useEffect(() => {
    if (actionTriggered) {
      setActionTriggered(false); // Ri-inicializo gjendjen për veprime të ardhshme

      if (openCashModal || openBankModal) {
        if (totaliFatures === 0) {
          errorAlert("Nuk ka asnje produkt ne grid per ta printuar kuponin");
          setOpenCashModal(false);
        } else {
          handleUpdatePayments();
        }
      }
      else if (openQtyModal) {
        handleChangeQtyWithInput(tempArticle, tempQty, "qty")
      }
      else if (openPriceModal) {
        handleChangeQtyWithInput(tempArticle, tempPrice, "price")
      }
      else if (isInactive) {
        refreshComponent();
      }
      else {
        if (searchByBarcode) {
          fetchArticlesSalesPriceByBarcode(barcode);
        } else {
          handleNewSubmit();
        }
      }
    }
  }, [actionTriggered, searchByBarcode, barcode, openCashModal, openBankModal, totaliFatures, openQtyModal, tempArticle, tempQty, isInactive, openPriceModal, tempPrice]);


  // `useEffect` për të regjistruar dhe hequr event listener-in për tastierën
  useEffect(() => {
    const handleKeyDown = (event) => handleKeyPress(event);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyPress]);



  //E hap modalin e pageses me CASH
  const openModalAndSelectText = () => {
    setOpenCashModal(true);
    // Delay focus to ensure state change is processed
    setTimeout(() => {
      if (pagesaArke.current) {
        pagesaArke.current.select();
      }
    }, 0);
  };


  // Funksioni për të gjeneruar përmbajtjen e file-it .txt
  const generateReceiptContent = (data) => {
    let fileContent = "";
    fileContent += `Q,1,______,_,__;1;Fatura: POS-${fiscalYear}-${invoiceNR}\n`;
    fileContent += `Q,1,______,_,__;2;Arkatari:${logedEmail}\n`;

    data.map((item, index) => {
      fileContent += `S,1,______,_,__;${item.ArticleName};${item.PriceWithVAT};${item.QtyOutput};1;1;${(item.VATRates == 18) ? 5 : (item.VATRates == 8) ? 4 : 1};${item.Barcode};${item.Barcode};\n`;
    });

    fileContent += "T,1,______,_,__;\n";

    return fileContent;
  };

  // Funksioni për të krijuar dhe shkarkuar file-in .txt
  const downloadReceiptFile = (data) => {
    const fileContent = generateReceiptContent(data);
    const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `POS-${fiscalYear}-${invoiceNR}.inp`);
  };


  // Funksioni për të gjeneruar ZRaportin
  const generateZRaport = () => {
    let fileContent = "";
    fileContent += `E,1,______,_,__;Printo Z raportin;F-Link ks\n`;
    fileContent += `Z,1,______,_,__;\n`;
    fileContent += "E,1,______,_,__;F-Link ks Enternet\n";

    return fileContent;
  };

  // Funksioni për të shkarkuar ZRaportin
  const downloadZraport = () => {
    const fileContent = generateZRaport();
    const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `ZRaport.inp`);
    setOpenZraportConfirm(false);
  };

  // Funksioni për të shkarkuar XRaportin
  const generateXRaport = () => {
    let fileContent = "";
    fileContent += `E,1,______,_,__;Printo X raportin;F-Link ks\n`;
    fileContent += `X,1,______,_,__;\n`;
    fileContent += "E,1,______,_,__;F-Link ks Enternet\n";

    return fileContent;
  };

  // Funksioni për të shkarkuar XRaportin
  const downloadXRaport = () => {
    const fileContent = generateXRaport();
    const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `XRaport.inp`);
    setOpenXraportConfirm(false);
  };


  // Funksioni për të rinisur kohën e pasivitetit
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);  // Fshij timer-in ekzistues
    }
    // Rinis timer për 2 minuta (120000 ms)
    timerRef.current = setTimeout(() => setIsInactive(true), 120000);
  };

  // Funksioni që rifreskon komponentin
  const refreshComponent = () => {
    setIsInactive(false);  // Hiq overlay-in dhe e bën faqen aktive përsëri
    setRefreshKey(prevKey => prevKey + 1);  // Ndryshon refreshKey për të rifreskuar komponentët
    resetTimer();  // Rinis timer pas rifreskimit
    setShowDeleteTransactionID(false);
    fetchLastInvoiceNr();
    setData([]);
    fetchArticleGroup([]);
    setValueDetails([]);
    setTotaliFatures(0);
    setKusuri(0);
    setPagesa(0);
    setInsertedTransaction(false)
    setShowPriceError(false);
    setCurrentDate(); // Vendos datën aktuale

    setTimeout(() => barcodeRef.current?.focus(), 0);

  };


  const closePOSModal = () => {
    // Kontrolloni nëse ka një transaksion të futur
    if (!insertedTransaction) {
      navigateToPos(); // Navigoni në POS
      setShowClosePOSModal(false); // Mbyllni modalin
      return; // Dalim nga funksioni
    }

    // Nëse ka një transaksion të futur, kontrolloni totalin e faturës
    if (totaliFatures === 0) {
      setShowClosePOSModal(true); // Trego modalin për mbyllje
    } else if (totaliFatures > 0) {
      setShowClosePosAlert(true); // Trego alarmin për totalin e faturës
    }
  };


  const showPayAlert = () => {
    errorAlert("Nuk ka asgjë për tu paguar");
  }


  useEffect(() => {
    // Vendosim resetimin e timer-it për lëvizje të mausit dhe shtypje të tastit
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);

    // Rinis timer kur komponenti ngarkohet
    resetTimer();

    return () => {
      // Hiq eventet kur komponenti unmount
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      if (timerRef.current) {
        clearTimeout(timerRef.current);  // Fshij timer-in kur komponenti largohet
      }
    };
  }, []);


  useEffect(() => {
    getUnitID(headers).then(setUnID);
  }, [headers])

  useEffect(() => {
    fetchLastInvoiceNr();
  }, []);

  useEffect(() => {
    // fetchClients();
    fetchArticles();
    fetchCompaniesData();
    fetchTransactionID();
    fetchArticleGroup();
    fetchBanks();
    fetchUserDetails();
    fetchPOS();
    setCurrentDate(); // Vendos datën aktuale

  }, [logedEmail, invoiceNR, clientID, articleID]);
  return (
    <>
      {isInactive && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Stack sx={{ width: '50%' }} spacing={2}>
            <Alert severity="warning" style={{ fontWeight: "bold" }}>POS-i juaj është pasivizuar pas 5 minutave pauzë!</Alert>
          </Stack>
          {/* <button
            style={{
              padding: "20px",
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={refreshComponent}
          >
            Rifillo Shitjen
          </button> */}
          <br></br>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="warning"
              style={{
                padding: "20px",
                fontSize: "20px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
              onClick={refreshComponent}  >
              Rifillo Shitjen
            </Button>
          </Stack>
        </div>
      )}
      <div className="POS__Container" key={refreshKey}>
        <Modal_bootstrap show={showDeleteTransactionID} onHide={() => setShowDeleteTransactionID(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Konfirmim</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body>
            <p>A dëshironi ta anuloni faturën</p>
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setShowDeleteTransactionID(false)}>
              JO
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" onClick={() => handleDeleteTransactionID("show")}>
              PO
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal_bootstrap show={showClosePOSModal} onHide={() => setShowClosePOSModal(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Mbyll Modalin</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body>
            <p>Keni nje transaksion pa artikuj te lene pezull, nese deshironi ta mbyllni POS-in, transaksioni do te fshihet </p>
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setShowClosePOSModal(false)}>
              Qendro ne POS
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" onClick={() => { navigateToPos(); handleDeleteTransactionID(); }}>
              Mbyll POS-IN
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal_bootstrap show={openZraportConfirm} onHide={() => setOpenZraportConfirm(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Konfirmim</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body>
            <p>A dëshironi ta printoni Z-Raportin</p>
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setOpenZraportConfirm(false)}>
              JO
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" onClick={downloadZraport}>
              PO
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal_bootstrap show={openXraportConfirm} onHide={() => setOpenXraportConfirm(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Konfirmim</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body>
            <p>A dëshironi ta printoni X-Raportin</p>
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setOpenXraportConfirm(false)}>
              JO
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" onClick={downloadXRaport}>
              PO
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal_bootstrap show={openQtyModal} onHide={() => setOpenQtyModal(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Ndrysho sasin</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body style={{ display: "flex", flexDirection: "column" }}>
            <TextField
              id="outlined-read-only-input"
              label="Emertimi artikullit"
              value={tempArticle.ArticleName}
              InputProps={{ readOnly: true }}
            />
            <br />
            <TextField
              id="outlined-read-only-input"
              label="Sasia"
              value={tempQty}
              autoComplete="off"
              onChange={(e) => setTempQty(e.target.value)}
              inputRef={qtyInputField}
            />
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setOpenQtyModal(false)}>
              Anulo
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" type="submit" onClick={() => { handleChangeQtyWithInput(tempArticle, tempQty, "qty") }}>
              Ruaj
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal_bootstrap show={openPriceModal} onHide={() => setOpenPriceModal(false)} style={{ marginTop: "150px" }}>
          <Modal_bootstrap.Header>
            <Modal_bootstrap.Title>Ndrysho Qmimin</Modal_bootstrap.Title>
          </Modal_bootstrap.Header>
          <Modal_bootstrap.Body style={{ display: "flex", flexDirection: "column" }}>
            <TextField
              id="outlined-read-only-input"
              label="Emertimi artikullit"
              value={tempArticle.ArticleName}
              InputProps={{ readOnly: true }}
            />
            <br />
            <TextField
              id="outlined-read-only-input"
              label="Qmimi"
              value={tempPrice}
              autoComplete="off"
              onChange={(e) => setTempPrice(e.target.value)}
              inputRef={priceInputField}
            />
          </Modal_bootstrap.Body>
          <Modal_bootstrap.Footer>
            <Button_Bootstrap variant="secondary" onClick={() => setOpenPriceModal(false)}>
              Anulo
            </Button_Bootstrap>
            <Button_Bootstrap variant="danger" type="submit" onClick={() => { handleChangeQtyWithInput(tempArticle, tempPrice, "price") }}>
              Ruaj
            </Button_Bootstrap>
          </Modal_bootstrap.Footer>
        </Modal_bootstrap>

        <Modal
          open={openCashModal}
          onClose={() => setOpenCashModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ width: "auto", bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
            <Typography sx={{ backgroundColor: "lightgreen", m: 1, height: "30px", color: "black", fontWeight: "bold", fontSize: "20px", textAlign: 'center' }}>{cashRegisterName}</Typography>
            <FormControl sx={{ m: 1 }} variant="filled" focused>
              <InputLabel htmlFor="Totali" style={{ color: "white" }}>
                Totali
              </InputLabel>
              <FilledInput
                id="Totali"
                style={{
                  height: "80",
                  fontSize: "40px",
                  backgroundColor: "black",
                  color: "white",
                }}
                value={totaliFatures > 0
                  ? totaliFatures.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })
                  : "0.00"
                }
                readOnly
              // startAdornment={<InputAdornment position="start" style={{fontSize:"40px" }}>€</InputAdornment>}
              />
            </FormControl>
            <br></br>
            <FormControl sx={{ m: 1 }} variant="filled" focused>
              <InputLabel htmlFor="Pagesa" style={{ color: "black" }}>
                Pagesa
              </InputLabel>
              <FilledInput
                id="Pagesa"
                inputRef={pagesaArke} // Këtu caktohet referenca
                style={{
                  height: "80px",
                  fontSize: "40px",
                  backgroundColor: "lightgreen",
                  color: "black",
                }}
                value={pagesa.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                onChange={(e) => setPagesa(e.target.value)}
                onKeyUp={(event) => kalkuloKusur(event.target.value)}
                autoComplete="off"
              />
            </FormControl>

            <br></br>
            <FormControl sx={{ m: 1 }} variant="filled" focused>
              <InputLabel htmlFor="Kusur" style={{ color: "white" }}>
                Kusur
              </InputLabel>
              <FilledInput
                id="Kusur"
                style={{
                  height: "80",
                  fontSize: "40px",
                  backgroundColor: "red",
                  color: "black",
                }}
                value={kusuri > 0
                  ? kusuri.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })
                  : "0.00"
                }
                readOnly
              // startAdornment={<InputAdornment position="start" style={{fontSize:"40px" }}>€</InputAdornment>}
              />
            </FormControl>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
              <Button variant="contained" color="secondary" onClick={() => { setOpenCashModal(false); }} sx={{ width: "45%" }}>Mbyll</Button>
              <Button variant="contained" type="submit" onClick={handleUpdatePayments} sx={{ width: "45%" }}>Shtyp</Button>
              {/* <button onClick={() => downloadReceiptFile(purchaseInvoice)}>Generate Receipt File</button> */}

            </Box>
          </Box>
        </Modal>

        <Modal
          open={openBankModal}
          onClose={() => setOpenBankModal(false)}
          aria-labelledby="update-modal-title"
          aria-describedby="update-modal-description"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", width: "auto", bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
            <FormControl sx={{ m: 1 }} variant="filled" focused>
              <InputLabel htmlFor="Totali" style={{ color: "white" }}>
                Totali
              </InputLabel>
              <FilledInput id="Totali" style={{
                height: "80",
                fontSize: "40px",
                backgroundColor: "black",
                color: "white",
              }}
                value={totaliFatures > 0
                  ? totaliFatures.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })
                  : "0.00"
                }
                readOnly
              />
            </FormControl>
            {
              banks &&
              banks.map((bank, index) => (
                <>
                  <FormControl sx={{ alignItems: "center", m: 1 }} variant="filled" focused>
                    <Button variant="contained" color={(paymentOptions == bank.AccountID) ? "success" : "primary"} index={index} sx={{ width: "100%" }} type="submit" onClick={(e) => setPaymentOptions(bank.AccountID)}>{bank.AccountName}</Button>
                  </FormControl>
                </>

              ))
            }
            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
              <Button variant="contained" color="secondary" onClick={() => { setOpenBankModal(false); }} sx={{ width: "45%" }}>Mbyll</Button>
              <Button variant="contained" type="submit" onClick={handleUpdatePayments} sx={{ width: "45%" }}>Shtyp</Button>
            </Box>
          </Box>
        </Modal>

        <div className="POS__Container__Header">
          <div>
            <h5><AccountCircleIcon /> {logedEmail.split("@acctree.net")}</h5>
          </div>
          <div>
            <h5><AccessTimeFilledIcon /> Ora: {formattedTime}</h5>
          </div>
          <div>
            <h5><DateRangeIcon />Data: {formattedDate}</h5>
          </div>
          <div>
            <h5><BusinessIcon /> {companyName && companyName}</h5>
          </div>
        </div>
        <hr></hr>
        <div className="POS__Container__Body">
          <div className="POS__Container__LeftSide">
            <div className="POS__Container__LeftSide__ClientDetails">
              <div className="POS__Container__LeftSide__ClientDetails__left">
                <div className="POS__Container__LeftSide__Client">
                  <TextField
                    style={{ width: "100%" }}
                    id="Client"
                    name="Client"
                    value={clientName}
                    // onKeyUp={(event) => fetchArticlesSalesPriceByBarcode(event.target.value)}
                    label="Klienti"
                    variant="filled"
                    readOnly
                  />
                </div>
                <br></br>
                <div className="POS__Container__LeftSide__Article">
                  <div className="POS__Container__LeftSide__Article__fields">
                    {searchByBarcode ? (
                      <>
                        <TextField
                          style={{ width: "100%" }}
                          id="barcode"
                          name="barcode"
                          value={barcode}
                          onChange={(event) => { setBarcode(event.target.value); setShowPriceError(false) }}
                          // onKeyUp={(event) => fetchArticlesSalesPriceByBarcode(event.target.value)}
                          label="Kerko me barkod"
                          variant="filled"
                          autoComplete="off"
                          onKeyPress={handleKeyPress}
                          inputRef={barcodeRef} // Përdorni inputRef për të referuar fushën

                        />
                      </>
                    ) : (
                      <Autocomplete
                        fullWidth
                        {...defaultPropsArticle}
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangeArticle}
                        value={selectArticleField}
                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID} // Shto funksionin isOptionEqualToValue
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Kerko Artikullin"
                            variant="filled"
                            onKeyPress={handleKeyPress}
                            inputRef={articleList}
                          />
                        )}
                      />
                    )}
                  </div>
                  <div className="POS__Container__LeftSide__Article__button">
                    {searchByBarcode ? (
                      <Button
                        variant="outlined"
                        style={{
                          borderRadius: "0px",
                          height: "56px",
                          width: "100%",
                        }}
                        startIcon={<KeyboardIcon />}
                        onClick={(e) => setSearchByBarcode(false)}
                      >
                        {/* Kerko me emertim */}
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        style={{ borderRadius: "0px", height: "56px" }}
                        startIcon={<QrCode2Icon />}
                        onClick={(e) => setSearchByBarcode(true)}
                      >
                        {/* Kerko me barkod */}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div className="POS__Container__LeftSide__ClientDetails__Right">
                <FormControl fullWidth sx={{ m: 0 }} variant="filled" focused>
                  <InputLabel htmlFor="Totali" style={{ color: "white" }}>
                    Totali
                  </InputLabel>
                  <FilledInput
                    id="Totali"
                    style={{
                      height: "140px",
                      fontSize: "40px",
                      backgroundColor: "black",
                      color: "white"
                    }}
                    value={
                      valuedetails &&
                        valuedetails.length > 0 &&
                        valuedetails[0].Total !== null &&
                        valuedetails[0].Total !== 0
                        ? valuedetails[0].Total.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                        : "0.00"
                    }
                    readOnly
                  // startAdornment={<InputAdornment position="start" style={{fontSize:"40px" }}>€</InputAdornment>}
                  />
                </FormControl>
              </div>
            </div>
            {openQtyAlert && (
              <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert variant="filled" severity="warning">
                  Ju lutem selektoni artikullin që dëshironi ta editoni
                </Alert>
              </Stack>
            )}
            {
              showPriceError && showPriceError ?
                <Alert severity="error" variant="filled" >
                  Kujdes! Artikulli: {articleName} është duke u shitur pa profit
                </Alert>
                : null
            }
            <div className="POS__Container__LeftSide__ArticleList" >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  border: "solid lightgray 1px",
                  "& .super-app-theme--header": {
                    backgroundColor: "#466F86",
                    color: "white",
                  },
                }}
              >
                <DataGrid
                  rows={rows}
                  columns={[
                    ...columns,
                    {
                      field: "actions",
                      headerName: "Veprimet",
                      sortable: false,
                      headerClassName: "super-app-theme--header",
                      width: 200,
                      renderCell: (params) => (
                        <div>
                          <AddCircleOutlineIcon
                            style={{ color: "green", width: "35px", height: "35px" }}
                            type="submit"
                            onClick={() => handleChangeQty(params.row.rowInfo, 1, '+')}
                          />
                          <RemoveCircleOutlineRoundedIcon
                            style={{ color: "orange", width: "35px", height: "35px" }}
                            type="submit"
                            onClick={() => handleChangeQty(params.row.rowInfo, 1, '-')}
                          />
                          <HighlightOffSharpIcon
                            style={{ color: "red", width: "35px", height: "35px" }}
                            type="submit"
                            onClick={() => handleDelete(params.row.itemID)}
                          />
                        </div>
                      ),
                    },
                  ]}
                  pageSize={100}
                  getRowClassName={(params) =>
                    params.row.sasia === 0 ? "zero-balance-row" : "non-zero-balance-row"
                  }
                  initialState={{
                    density: 'compact'
                  }}
                  onRowClick={(params) => {
                    setTempArticle(params.row.rowInfo);
                    setTempQty(params.row.rowInfo.QtyOutput);
                    setTempPrice(params.row.rowInfo.PriceWithVAT);
                    setIsArticleQtySelected(true);
                    setOpenQtyAlert(false);

                    // Mund ta përdorni këtë të dhënë për të kryer veprime të tjera
                  }}
                />
                <style jsx>{`
                .zero-balance-row {
                  background-color: lightgray;
                }
                .non-zero-balance-row {
                  /* Stili për rreshtat kur 'balance' nuk është 0 */
                }
              `}</style>
              </Box>
            </div>
            <div className="POS__Container__LeftSide__Total">
              <div className="POS__Container__LeftSide__Total__Fields">
                <div className="POS__Container__LeftSide__Total__Fields__First">
                  <div className="POS__Container__LeftSide__Total__Fields__First__values">
                    <div >
                      <FormControl
                        fullWidth
                        sx={{ m: 0 }}
                        variant="filled"
                        focused
                      >
                        <InputLabel htmlFor="TotalAmount">
                          Total pa TVSH
                        </InputLabel>
                        <FilledInput
                          id="TotalAmount"
                          value={
                            valuedetails &&
                              valuedetails.length > 0 &&
                              valuedetails[0].Amount18 !== undefined &&
                              valuedetails[0].Amount8 !== undefined &&
                              valuedetails[0].Amount0 !== undefined
                              ? (
                                valuedetails[0].Amount18 +
                                valuedetails[0].Amount8 +
                                valuedetails[0].Amount0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                              })
                              : "0.00"
                          }
                          readOnly
                          startAdornment={
                            <InputAdornment position="start">€</InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                    <div >
                      <FormControl
                        fullWidth
                        sx={{ m: 0 }}
                        variant="filled"
                        focused
                      >
                        <InputLabel htmlFor="VATTotal">Total TVSH</InputLabel>
                        <FilledInput
                          id="VATTotal"
                          value={
                            valuedetails &&
                              valuedetails.length > 0 &&
                              valuedetails[0].Total !== undefined &&
                              valuedetails[0].Amount18 !== undefined &&
                              valuedetails[0].Amount8 !== undefined &&
                              valuedetails[0].Amount0 !== undefined
                              ? (
                                valuedetails[0].Total -
                                (valuedetails[0].Amount18 +
                                  valuedetails[0].Amount8 +
                                  valuedetails[0].Amount0)
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                              })
                              : "0.00"
                          }
                          readOnly
                          startAdornment={
                            <InputAdornment position="start">€</InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                    <div >
                      <FormControl
                        fullWidth
                        sx={{ m: 0 }}
                        variant="filled"
                        focused
                      >
                        <InputLabel htmlFor="VATTotal">Total</InputLabel>
                        <FilledInput
                          id="Total"
                          value={totaliFatures > 0
                            ? totaliFatures.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                            : "0.00"
                          }
                          readOnly
                          startAdornment={
                            <InputAdornment position="start">€</InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="POS__Container__RightSide">
            <div className="POS__Container__RightSide__Top">
              <Box sx={{ width: "100%" }}>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{ padding: "5px" }}
                >
                  {articleGroup &&
                    articleGroup.map((gr, index) => (
                      <Grid item xs={3} index={index}>
                        <Item
                          style={{
                            backgroundColor: "blue",
                            color: "white",
                            height: "60px",
                            alignContent: "center",
                          }}
                          type="submit"
                          onClick={() => fetchArticleByGroup(gr.GroupID)}
                        >
                          {gr.GroupName}
                        </Item>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </div>
            <div className="POS__Container__RightSide__Middle">
              <Box sx={{ width: "100%" }}>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{ padding: "5px" }}
                >
                  {articleByGroup &&
                    articleByGroup.map((gr, index) => (
                      <Grid item xs={3} index={index}>
                        <Item
                          style={{
                            backgroundColor: "lightgreen",
                            color: "black",
                            height: "70px",
                            alignContent: "center",
                          }}
                          type="submit"
                          onClick={() => insertArticlerOnClick(gr.ArticleID)}
                        >
                          {gr.ArticleName}
                        </Item>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </div>
            <div className="POS__Container__RightSide__Bottom">
              <Box sx={{ width: "100%" }}>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{ padding: "5px" }}
                >
                  <Grid item xs={4}>
                    <Item
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        height: "100px",
                        alignContent: "center",
                        fontSize: "25px",
                      }}
                      type="submit"
                      onClick={() => {
                        if (totaliFatures === 0) {
                          showPayAlert();
                        } else {
                          setPaymentOptions(tempPaymentOption);
                          openModalAndSelectText();
                        }
                      }}
                    >
                      Paguaj me Cash <EuroIcon />
                    </Item>
                  </Grid>

                  <Grid item xs={4}>
                    <Item
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        height: "100px",
                        alignContent: "center",
                        fontSize: "25px",
                      }}
                      type="submit"
                      // onClick={() => setOpenBankModal(true)}
                      onClick={() => {
                        if (totaliFatures === 0) {
                          showPayAlert();
                        } else {
                          setOpenBankModal(true)
                        }
                      }}
                    >
                      Paguaj me bankë <PaymentIcon />
                    </Item>
                  </Grid>
                  {/* <Grid item xs={4}>
                    <Item
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        height: "100px",
                        alignContent: "center",
                        fontSize: "25px",
                      }}
                      type="submit"
                      onClick={() => {
                        (paymentOptions != 0 || totaliFatures != 0) ? setShowClosePosAlert(true) : navigateToPos()
                      }}
                    >
                      Mbyll <CancelIcon />
                    </Item>
                  </Grid> */}

                  <Grid item xs={4}>
                    <Item
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        height: "100px",
                        alignContent: "center",
                        fontSize: "25px",
                      }}
                      type="submit"
                      onClick={closePOSModal}
                    >
                      Mbyll <CancelIcon />
                    </Item>
                  </Grid>

                  {/* <Grid item xs={3}>
                                    <Item style={{ backgroundColor: "orange", color: "black", height: "70px", alignContent: "center", fontSize: "25px" }}>50€</Item>
                                </Grid> */}
                </Grid>
              </Box>
              {
                showClosePosAlert ?
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert variant="filled" severity="error">
                      Nuk mund ta mbyllni POS-in sepse nuk është paguar ende fatura
                    </Alert>
                  </Stack>
                  :
                  <></>
              }
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="POS__Container__Footer">
          <p>F1: Kërko me barkod</p>
          <p>F2: Kërko në listë</p>
          <p>F4: Cmimi</p>
          <p>F5: Sasia</p>
          <p>F6: Hap Arkën</p>
          <p>F7: Hap Bankën</p>
          <p>F10: X Raport</p>
          <p>F11: Z Raport</p>
          <p>F12: Anulo faturën</p>
        </div>
      </div >
    </>
  );
}
export default AddPos;
